module.exports = __webpack_public_path__ + "img/EVEN0007.929a6270.png";